import axios from 'axios'
import CognitoService from '@/services/CognitoService.js'

export const uploadS3Object = function(uploadSignedUrl, file, fileType) {
	return axios.put(uploadSignedUrl, file, {
		headers: {
			Accept: 'application/json',
			'Content-Type': fileType
		}
	})
}

export const getUploadSignedUrl = async function(
	folder,
	filename,
	mediatype,
	subtype
) {
	await CognitoService.checkTokenExpire()
	const token = sessionStorage.getItem('token')
	return axios.get(
		`/s3/gets3uploadsignedurl/${folder}/filename/${filename}/mediatype/${mediatype}/subtype/${subtype}`,
		{
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			}
		}
	)
}

export const getDownloadSignedUrl = async function(folder, filename) {
	await CognitoService.checkTokenExpire()
	const token = sessionStorage.getItem('token')
	return axios.get(`/s3//gets3objecturl/${folder}/filename/${filename}`, {
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		}
	})
}
